import { Grid, Layout } from 'antd';
import Footer from 'components/Footer';
import HeaderNav from 'components/HeaderNav';
import MobileNav from 'components/MobileNav';
import PageHeader from 'components/PageHeader';
import SideNav from 'components/SideNav';
import TopNav from 'components/TopNav';
import { FIRM_ID } from 'constants/StorageConstant';
import { DIR_LTR, DIR_RTL, NAV_TYPE_SIDE, NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import helperFunc from 'helpers/helperFunc';
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import tools from 'tools';
import { selectActivityStatusList } from 'utils/redux/actions/activityStatusActions';
import { appListener } from 'utils/redux/actions/appListenerActions';
import { selectHomePageNotificationList, selectUnreadNotificationCount } from 'utils/redux/actions/notiificationActions';
import { selectChatList } from 'utils/redux/actions/chatActions';
import * as signalR from '@microsoft/signalr';
import { API_BASE_URL } from 'constants/ApiConstant';
import globalConstant from 'constants/globalConstant';


function AppLayout({ navCollapsed, navType, direction, appListenerAction
  , selectActivityStatusListAction, selectHomePageNotificationListActions, selectUnreadNotificationCountActions, selectChatListAction,selectChatListDetailAction }) {
  const { Content } = Layout;
  const { useBreakpoint } = Grid;
  navType = "SIDE";
  direction = DIR_LTR;
  const navigationConfig = helperFunc.getLeftMenuList();
  const currentRouteInfo = tools.getRouteInfo(navigationConfig, "/")

  const [currentRoute, setCurrentRoute] = useState(currentRouteInfo);
  const screens = tools.getBreakPoint(useBreakpoint());
  const [selectedApp, setSelectedApp] = useState("");

  const isMobile = screens.length === 0 ? false : !screens.includes('lg')
  const isNavSide = navType === NAV_TYPE_SIDE
  const isNavTop = navType === NAV_TYPE_TOP
  const firmId = localStorage.getItem(FIRM_ID);
  const firmAdminState = JSON.parse(localStorage.getItem('isFirmAdmin'));
  const signalRConnectionRef = useRef(null);
  const isConnectListener = useRef(false);
  const notificationAudioRef = useRef(null);


  const navigate = useNavigate();


  const handleChangeApp = (value, menuListData) => {
    setSelectedApp(value);
    const selectedApp = menuListData.find((app) => app.appName === value);
    if (selectedApp) {
      localStorage.setItem('selectedApp', JSON.stringify(selectedApp));
    }
  };

  useEffect(() => {
    const storedSelectedApp = JSON.parse(localStorage.getItem('selectedApp'));
    if (storedSelectedApp != null) {

      setSelectedApp(storedSelectedApp.appName);
    }
  }, []);


  useEffect(() => {
    if (!firmAdminState) {
      navigate('/barista-screen');
    }
    if (!firmAdminState && firmId == 5) {
      navigate('/kodsan-report');
    }
  }, [firmAdminState, navigate]);

  useEffect(() => {
    if (isConnectListener.current == false) {
      const hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}/messagehub`, {})
        .build();


      signalRConnectionRef.current = hubConnection;

      hubConnection.on('whatsappListener_' + firmId, onOrderReceived);


      function startConnection() {
        hubConnection.start().catch(err => { reconnect(); }).then(response => {

          isConnectListener.current = true;
        });
      }
      startConnection();

      function reconnect() {

        setTimeout(startConnection, 2000);
      }

      hubConnection.onclose(reconnect);
    }

  }, []);

  // useEffect(() => {

  //   const hubUpdateConnection = new signalR.HubConnectionBuilder()
  //     .withUrl(`${API_BASE_URL}/updatehub`, {}).build();




  //   function startConnection() {
  //     hubUpdateConnection.start().catch(err => { reconnect(); }).then(response => {

  //       hubUpdateConnection.on('ReceiveUpdate', () => {

  //         window.location.reload();
  //       });
  //       isConnectListener.current = true;
  //     });
  //   }
  //   startConnection();

  //   function reconnect() {

  //     setTimeout(startConnection, 2000);
  //   }

  //   hubUpdateConnection.onclose(reconnect);
  // }, [])
  const onOrderReceived = (data) => {
    appListenerAction(data);
    var listenerType = data.type;
    if (listenerType == globalConstant.listenerTypes.neworder || listenerType == globalConstant.listenerTypes.newcustomer) {
      selectHomePageNotificationListActions();
      selectUnreadNotificationCountActions();
    }
    if (listenerType == globalConstant.listenerTypes.connectCustomerService) {
      if (notificationAudioRef.current) {
        notificationAudioRef.current.currentTime = 0;
        notificationAudioRef.current.play();
      }
      selectChatListAction();
    }
  }


  useEffect(() => {
    selectActivityStatusListAction();
  }, []);

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter(), minWidth: "100%" }
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter(), minWidth: "100%" }
    }
    return { paddingLeft: getLayoutGutter(), minWidth: "100%" }
  }

  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
  }
  return (
    <>
      <audio ref={notificationAudioRef} src="/notification.mp3" preload="auto" />
      <HeaderNav isMobile={isMobile} selectedApp={selectedApp} />
      {(isNavTop && !isMobile) ? <TopNav routeInfo={currentRoute} /> : null}
      {(!firmAdminState) ?
        <Layout className="app-container ">
          <Content className='mt-3'>
            <Outlet />
          </Content>
        </Layout> :
        <Layout className="app-container">
          {(isNavSide && !isMobile) ? <SideNav routeInfo={currentRoute} handleChange={handleChangeApp}
            selectedValue={selectedApp} /> : null}
          <Layout className="app-layout" style={getLayoutDirectionGutter()}>
            <div className={`app-content pt-2 ${isNavTop ? 'layout-top-nav' : ''}`}>
              <PageHeader display={currentRoute?.breadcrumb} title={currentRoute?.title} />
              <Content>
                <Outlet />
              </Content>
            </div>
            <Footer />
          </Layout>
        </Layout>}


      {isMobile && <MobileNav />}
    </>

  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;

  return { navCollapsed, navType, locale, }
};
function mapDispatchToProps(dispatch) {
  return {
    appListenerAction: bindActionCreators(appListener, dispatch),
    selectHomePageNotificationListActions: bindActionCreators(selectHomePageNotificationList, dispatch),
    selectUnreadNotificationCountActions: bindActionCreators(selectUnreadNotificationCount, dispatch),
    selectActivityStatusListAction: bindActionCreators(selectActivityStatusList, dispatch),
    selectChatListAction: bindActionCreators(selectChatList, dispatch),
    selectChatListDetailAction:bindActionCreators(selectChatList, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));
// export default AppLayout;
